/* FDWS Header — hover mega menu + transparent-at-top header */
(function () {
  var canHover = function () {
    return window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
  };

  function closeMenu(d) {
    d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  function initHover(scope) {
    (scope || document).querySelectorAll('.fdws-mega details.mega-menu').forEach(function (d) {
      if (d.dataset.fdwsHover) return;
      d.dataset.fdwsHover = '1';
      var li = d.closest('li');
      var s = d.querySelector('summary');
      var timer;
      li.addEventListener('mouseenter', function () {
        if (!canHover()) return;
        clearTimeout(timer);
        document.querySelectorAll('.fdws-mega details.mega-menu[open]').forEach(function (o) {
          if (o !== d) closeMenu(o);
        });
        d.setAttribute('open', '');
        if (s) s.setAttribute('aria-expanded', 'true');
      });
      li.addEventListener('mouseleave', function () {
        if (!canHover()) return;
        timer = setTimeout(function () { closeMenu(d); }, 220);
      });
    });
  }

  function initTransparent() {
    var wrap = document.querySelector('.header-wrapper.fdws-th-enabled');
    if (!wrap || wrap.dataset.fdwsTh) return;
    wrap.dataset.fdwsTh = '1';
    var sec = wrap.closest('.section-header') || wrap.parentElement;
    sec.classList.add('fdws-th');
    var hovering = false;

    function setHeight() {
      document.documentElement.style.setProperty('--header-height', sec.offsetHeight + 'px');
    }
    function update() {
      var clear =
        window.scrollY <= 10 &&
        !hovering &&
        !sec.querySelector('details[open]') &&
        !sec.querySelector(':focus-visible');
      wrap.classList.toggle('fdws-th--clear', clear);
    }

    wrap.addEventListener('mouseenter', function () { hovering = true; update(); });
    wrap.addEventListener('mouseleave', function () { hovering = false; update(); });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', setHeight);
    document.addEventListener('toggle', update, true);
    sec.addEventListener('focusin', update);
    sec.addEventListener('focusout', function () { setTimeout(update, 0); });
    setHeight();
    update();
  }

  function init(scope) {
    initHover(scope);
    initTransparent();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
